import moment from "moment-timezone";
import * as Yup from 'yup';
import { errorToaster } from "../../../reusable/common";
import { getCurrentEventId } from "../../../Utils/helpers";

export const eventId = getCurrentEventId();

export const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
export const SCREENS = {
    ADD_PREDEFINED_TASK: "AddPredefinedTask",
    EDIT_TASK: "EditTask",
    CREATE_TASK: "CreateTask",
    LIST_OF_TASKS: "listOfTasks",
    TASK_ANALYTICS:"TaskAnalytics",
    EXHIBITOR_TASKS: "ExhibitorTasks",
};
export const cleanPayload = (payload) => {
    return Object.keys(payload).reduce((acc, key) => {
      const value = payload[key];
  
      if (key === "exhibitors" || key === "task_analytics") return acc;
  
      if (value != null && !(Array.isArray(value) && value.length === 0)) {
        acc[key] = value;
      }
  
      return acc;
    }, {});
  };
  

export const validationSchema = Yup.object({
    title: Yup.string()
    .required('Task Title is required')
    .min(3, 'Task Title must be at least 3 characters long')
    .max(100, 'Task Title cannot exceed 100 characters')
    .matches(/^(?! )[A-Za-z0-9\-:()\[\]|,#/<>.&@+! ]+$/, 'Task Title cannot start with a space and may only contain letters, numbers, spaces, and special characters (-:()[]|,#/<>.&@+!).'),
    task_type: Yup.string()
        .required('Task Type is required'),
    description: Yup.string()
        .max(2000, 'Please enter less than 2000 characters')
        .nullable(),
});
export const LABELS = {
    CREATE_TASK: "Create Task",
    EDIT_TASK: "Edit Task"
};
export const TIME_FORMATS = {
    FORMAT_TYPE_1: "h:mm A, DD MMM YY",
    FORMAT_TYPE_2: "YYYY-MM-DD HH:mm:ss",
    FORMAT_TYPE_3: "MMM DD, YYYY",
};


export const TOGGLEMODE = {
    CATEGORY: "category",
    EXHIBITOR: "exhibitor",
};
export const getOptionLabel = (option) => (
    <div className="d-flex aligns-items-center">
        {option.image && (
            <img
                src={option.image}
                alt={option.label}
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />
        )}
        {option.icon && (
            <i className={option.icon} style={{ marginRight: "5px" }}></i>
        )}
        {option.label}
    </div>
);
export const ENTITY_MODULES = {
    EXHIBITOR: 'exhibitor',
};
export const handleError = (err) => {
    const errorMessage = err?.response?.data?.error;
    errorToaster(errorMessage);
};
export const mapEntities = (categorized, uncategorized) => {
    const categorizedEntities = categorized.flatMap(category =>
        category.entity.map(entity => ({
            category_name: entity.entity_name,
            category_id: entity.id,
            category_order: entity.entity_order,
        }))
    );

    const uncategorizedEntities = uncategorized.map(entity => ({
        category_name: entity.entity_name,
        category_id: entity.id,
        category_order: entity.entity_order,
    }));

    return [...categorizedEntities, ...uncategorizedEntities];
};
export const options = [
    { label: "Text", value: 1 },
    { label: "File", value: 3 },
    { label: "Information", value: 2 },
];
export const hardcodedTimeZone = "Asia/Kolkata";

export const formatDateWithTimeZone = (e, hardcodedTimeZone) => {
    return moment(e)
        .tz(hardcodedTimeZone)
        .format("YYYY-MM-DD HH:mm:ss")
        .replace(/ /g, "T");
};
export const FIELD_NAMES = {
    REMINDER_DATE: "reminder_date",
    DUE_DATE: "due_date"
};


export const priorityOptions = [
    {
        label: "High",
        value: 1,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad4047ac484000871fe7f/iconamoon_arrow-up-2.svg",
    },
    {
        label: "Medium",
        value: 2,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad43f7ac484000871fe85/iconamoon_arrow-up-2(5).svg",
    },
    {
        label: "Low",
        value: 3,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad40a7ac484000871fe83/iconamoon_arrow-up-2(3).svg",
    },
];
export const moduleData = [
    {
        module_id: 1,
        module_name: "Exhibitor Logo",
        task_type: 3,
        task_column_mapping: "image_url",
    },
    {
        module_id: 2,
        module_name: "Exhibitor Website URL",
        task_type: 1,
        task_column_mapping: "website_url",
    },
    {
        module_id: 3,
        module_name: "Description",
        task_type: 1,
        task_column_mapping: "description",
    },
    {
        module_id: 4,
        module_name: "Exhibitor Location",
        task_type: 1,
        task_column_mapping: "location",
    },
];
export const categoryEntity = {
    SPONSOR: 1,
    SPEAKER: 2,
    TICKET: 3,
    GALLERY: 4,
    PARTNER: 5,
    EXHIBITOR: 6
}
export const style = {
    color: "#572148",
    textDecoration: "none" ,
    cursor:"pointer"
};


export const convertToDateObj = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return null;
    }
    return date;
};
export const theme = {
    rainbow: {
        palette: {
            brand: "#572148",
        },
    },
};

export const getEventDateNTime = (date, eventTimeZone = "Asia/Kolkata") => {
    if (!date) return "N/A";

    return moment.utc(date).tz(eventTimeZone).format(TIME_FORMATS.FORMAT_TYPE_1) + " " + "IST";
};

export const getISTDateNTimeWTimeZone = (date) => {
    if (!date) return "N/A";
    return moment.utc(date) 
        .tz("Asia/Kolkata") 
        .format(TIME_FORMATS.FORMAT_TYPE_1) + " IST";
};
export const EXHIBITOR_TASK_STATUS = {
    PENDING: 1,
    SUBMITTED: 2,
    ACCEPTED: 3,
    APPROVED: 4,
    REJECTED: 5,
    RESUBMIT: 6,
    "RE-SUBMIT": 6
};

export const EXHIBITOR_TASK_TYPES =
 {  "TEXT" : 1,  "INFORMATION" :2 , "FILE" : 3  }

export const getStatusClassName = (status) => {  
    const statusClasses = {
      1: "status-pending",
      2: "status-submitted",
      3: "status-accepted",
      4: "status-approved",
      5: "status-rejected",
      6: "status-resubmit",
    };
  
    return `task-status-common ${statusClasses[status] || ""}`;
  };
  


export const analyticsResponse = {
    body: {
        analytics: {
            "1": 1,
            "2": 1,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0
        },
        exhibitors: [
            {
                exhibitor_id: 15942,
                updated_at: "2025-01-15T10:30:00Z",  
                task_status: 1, 
                assignment_id: "19aba90f-b436-4490-9ba9-a5fc6dfe1635",
                response_files: [],
                task_response: null,
                entity_name: "Exhibitor 1"
            },
            {
                exhibitor_id: 15943,
                updated_at: "2025-01-18T12:00:00Z",  
                task_status: 2,  
                assignment_id: "7fc9e72c-df4f-4c50-8f3d-537cf95e9e1e",
                response_files: ["file1.pdf", "file2.jpg"],
                task_response: "Approved",
                entity_name: "Exhibitor 2"
            },
            {
                exhibitor_id: 15944,
                updated_at: null,  
                task_status: 3,
                assignment_id: "d4c9b5b4-b59e-4c1c-b7a5-5b90b3ac1df2",
                response_files: [],
                task_response: null,
                entity_name: "Exhibitor 3"
            }
        ],
        count: 3  
    }
};

export const priorityBasedIcons = {
    HIGH: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad4047ac484000871fe7f/iconamoon_arrow-up-2.svg",
    MEDIUM: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad43f7ac484000871fe85/iconamoon_arrow-up-2(5).svg",
    LOW: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad40a7ac484000871fe83/iconamoon_arrow-up-2(3).svg",
    REDIRECT: "https://d2nnrpx7gk2my2.cloudfront.net/files/67ab7f4dbc42e900081ab4bd/Group.svg",
}

export const getRouteForLinkType = (linkType, eventId) => {
    if (linkType === "eventInfo") {
        return `/e/${eventId}/eventInfo/exhibitor/details`;
    } else if (linkType === "attendeeApp") {
        return `/e/${eventId}/attendee-app/settings/branding`;
    }else if(linkType === "exhibitorsPortal") {
        return `/e/${eventId}/exhibitor-portal/exhibitors`;
    }
    return "/";
};

export const getStatusClass = (status) => {
    switch (status) {
        case "Pending":
            return "pendingStatus task-status-common";
        case "Submitted":
            return "submittedStatus task-status-common";
        case "Approved":
            return "approvedStatus task-status-common";
        case "Rejected":
            return "rejectedStatus task-status-common";
        case "Re-submit":
            return "resubmitStatus task-status-common";
        default:
            return "defaultStatus task-status-common";
    }
};

export const filterTiles = [
    { id: 1, name: "Pending", status: "Pending" },
    { id: 2, name: "Submitted", status: "Submitted" },
    { id: 4, name: "Approved", status: "Approved" },
    { id: 5, name: "Rejected", status: "Rejected" },
    { id: 6, name: "Re-submit", status: "Re-submit" },
    { id: 3, name: "Accepted", status: "Accepted" },
];

export const getTaskStatusText = (status) => {
    switch (status) {
        case EXHIBITOR_TASK_STATUS.PENDING:
            return "Pending";
        case EXHIBITOR_TASK_STATUS.SUBMITTED:
            return "Submitted";
        case EXHIBITOR_TASK_STATUS.ACCEPTED:
            return "Accepted";
        case EXHIBITOR_TASK_STATUS.APPROVED:
            return "Approved";
        case EXHIBITOR_TASK_STATUS.REJECTED:
            return "Rejected";
        case EXHIBITOR_TASK_STATUS.RESUBMIT:
            return "Re-submit";
        default:
            return "Unknown";
    }
};

export const filterTaskByStatus  = {
    PENDING: 1,
    SUBMITTED: 2,
    ACCEPTED: 3,
    APPROVED: 4,
    REJECTED: 5,
    "RE-SUBMIT": 6
};

export const convertToUTC = (date) =>
    date ? moment(date).utc().format("YYYY-MM-DD HH:mm:ss") : null;

export const convertToEventTimeZone = (date,eventDetails) =>
	date ? moment.utc(date).tz(eventDetails?.time_zone).format("YYYY-MM-DD HH:mm:ss") : null;
